export enum NewsStatus {
    PENDING = 0,
    CLASSIFYING = 1,
    CLASSIFIED = 2,
    NOT_CLASSIFY = 3
}